import React from "react"
import { useStyle } from "react-native-style-utilities"

import type { BoxProps } from "./Box"

import { Box } from "./Box"

/**
 * A component that displays a circle.
 */
export function Circle({ style, ...rest }: BoxProps) {
  return (
    <Box
      style={useStyle(() => {
        return [
          {
            borderRadius: 9999,
            overflow: "hidden",
          },
          style,
        ]
      }, [style])}
      {...rest}
    />
  )
}
